import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';

const StThankYouWrapperContainer = styled(Grid)(({ theme }) => {
  return {
    background: `${theme.palette.white.main}`,
    padding: '4rem 2rem ',
    minHeight: `calc(100vh - 7rem)`,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    '.custom-link': {
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: '700',
      lineHeight: '24px',
      textDecoration: 'none',
      cursor: 'pointer',
    },
    '.mail-text': {
      lineHeight: '160%',
      paddingTop: '2rem',
      paddingBottom: '2rem',
      textAlign: 'left',
    },
    '.subtitle': {
      fontSize: '1rem',
      padingBottom: '5px',
      fontFamily: theme?.palette?.primaryFontFamilyType || 'Proxima Nova',
      color: theme.palette.black.main,
    },
    [theme.breakpoints.down('md')]: {
      '.sub-title': {
        fontSize: '1.5rem',
        fontWeight: '400',
      },
    },
  };
});

export default StThankYouWrapperContainer;
